import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export function PriceMatrixPage() {
  return (
    <div className="space-y-6">
      <div>
        <div className="flex items-center gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Price Matrix</h1>
          <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">
            🟡 Demo Mode
          </Badge>
        </div>
        <p className="text-muted-foreground mt-2">
          Manage pricing structures, customer-specific pricing, and volume discounts.
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Content Coming Soon</CardTitle>
          <CardDescription>
            This page will allow you to configure and manage complex pricing matrices for different customer segments.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <div className="text-sm text-muted-foreground">
            <p className="mb-2">Planned features:</p>
            <ul className="list-disc list-inside space-y-1">
              <li>Multi-tier pricing configuration</li>
              <li>Customer-specific pricing rules</li>
              <li>Volume-based discount tiers</li>
              <li>Price list management</li>
              <li>Bulk price updates</li>
            </ul>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
